export default "__VITE_ASSET__D8PKW1Qi__"